import {useEffect, useState} from "react";
import {Context} from "./component/Context";
import SubmitMetaData from "./component/SubmitMetaData";
import SubmitFile from "./component/SubmitFile";
import "./component/Style.css"
import {Translator, UploadFileType} from "component/const/ForTrans";
import {SubmitEdited} from "./component/SubmitEdited";
import {QuestionManageComponent} from "./component/QuestionManageComponent";
import {QuestionModifyComponent} from "./component/QuestionModifyComponent";
import {useLocation} from "react-router-dom";
import axios from "axios";
import {restUrl} from "../../../../../apiUrl";

export default function CreateTrans(){
    const [file, setFile] = useState(null)
    const [original, setOriginal] = useState("")
    const [testTranslator, setTestTranslator] = useState([Translator[0]])
    const [translate, setTranslate] = useState("")
    const [answer, setAnswer] = useState("")
    const [selectedTranslate,setSelectedTranslate] = useState("")
    const [fileType, setFileType] = useState(UploadFileType[0].value)
    const [submitVal, setSubmitVal] = useState(false)
    const [modify, setModify] = useState(false)
    const [meta, setMeta] = useState({
        source: "ko",
        target: "en",
    })
    const [metaData, setMetaData] = useState({
        translator:null,
        max:0,
        pass:0,
        checkStart:0,
        checkEnd:0,
        summary:"",
        memo:"",
    })


    useEffect(() => {
        init()
    }, []);

    const {state} = useLocation()
    const init = async () => {

        const m = await getMetaDataByTestId(state.testId)
        setMetaData(m.metaData)
        setMeta(m.meta)

        const translator = await getTranslatorsByTestId(state.testId)
        setTestTranslator(typeof translator === 'string'? JSON.parse(translator): translator)

        const problems = await getProblemsByTestId(state.testId)
        if (problems.length > 0) {
            const ori = await getOriginalByTestId(state.testId)
            setOriginal(ori)
            setModify(true)
            setSubmitVal(true)
        }
    }

    return(
        <div id={"element-style"}>
        <Context.Provider value={{file, setFile, metaData, setMetaData, meta, setMeta, fileType, setFileType,setSubmitVal,modify, setModify,
            original, setOriginal, answer, setAnswer, testTranslator, setTestTranslator, translate, setTranslate,setSelectedTranslate,selectedTranslate}}>
            <SubmitMetaData/>
            {!modify&& <SubmitFile state={state}/>}
            {(submitVal && selectedTranslate && !modify) && <QuestionManageComponent original={original} translate={translate}/>}
            {(submitVal && selectedTranslate !=='' && modify) && <QuestionModifyComponent original={original}/>}
            <SubmitEdited/>
        </Context.Provider>
        </div>
    )
}

const getProblemsByTestId = async (id) => {
    const { data } = await axios.get(`${restUrl}/activity_test_problem?select=test_id&test_id=eq.${id}`)
    return data
}

const getTranslatorsByTestId = async (id) => {
    const { data } = await axios.get(`${restUrl}/activity_test_metadata_trans?test_id=eq.${id}`)
    return data[0].translator
}

const getOriginalByTestId = async (id) => {
    const { data } = await axios.get(`${restUrl}/activity_test_problem_view_trans_create?test_id=eq.${id}`)
    return data
}

const getMetaDataByTestId = async (id) => {
    const res = await axios.get(`${restUrl}/activity_test?instance_id=eq.${id}`)
    const data = res.data[0]
    return {
        metaData: {
            translator: null,
            max: data.total_score,
            pass: data.pass_score,
            checkStart: data.notice_score,
            checkEnd: data.pass_score,
            summary: data.summary,
            memo: data.memo
        },
        meta: {
            source: data.start_language_code,
            target: data.target_language_code
        }
    }
}
